import {
  Form,
  Modal,
  ModalContext,
  Text,
  useFormState,
  useFormValidation,
} from 'dash-ui';
import { FormEvent, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

enum FormFields {
  Password = 'password',
}

const OpenPortfolioWithPasswordModal = () => {
  const { isOpenCurrent, payload } = useContext(ModalContext);
  const isOpen = isOpenCurrent['OpenPortfolioWithPasswordModal'];
  const theme = useTheme();
  const { t } = useTranslation();
  const [formState, [setPassword], [formOnSubmit]] = useFormState([
    FormFields.Password,
  ]);
  const [errorsState] = useFormValidation([FormFields.Password]);
  const formRef = useRef<HTMLFormElement | null>(null);

  const closeModal = () => {
    setPassword('');
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    formOnSubmit();
    if (payload.onSubmit) {
      payload.onSubmit(formState.password);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      blur
      title={
        t('pages:portfoliosPage.openPortfolioWithPasswordModal.title') || ''
      }
      onRequestClose={closeModal}
      submitButton={{
        w: '100%',
        mr: 0,
        title: t('common:labels.open'),
        isLoading: !!payload?.loading,
        disabled: !!payload?.loading,
        onClick: () => {
          if (formRef.current) {
            formRef.current.requestSubmit();
          }
        },
      }}
    >
      <Form className="protected-portfolio-modal-form" ref={formRef} onSubmit={onSubmit}>
        <Text color={theme.colors.n80}>
          {t('pages:portfoliosPage.openPortfolioWithPasswordModal.subtitle')}
        </Text>
        <Form.Group w="100%" mt={3}>
          <Form.Label>{t('forms:labels.password')}</Form.Label>
          <Form.Input
            required
            placeholder={t('forms:placeholders.enterPasswordToOpenLink') || ''}
            onChange={(e) => setPassword(e.target.value)}
            $errorType={errorsState[FormFields.Password]?.type}
          />
          <Form.Feedback $errorType={errorsState[FormFields.Password]?.type}>
            {errorsState[FormFields.Password]?.message}
          </Form.Feedback>
        </Form.Group>
      </Form>
    </Modal>
  );
};

export default OpenPortfolioWithPasswordModal;
